export default __webpack_public_path__ + "static/media/bad-reply.c24f6d96.svg";